import React from 'react';
import { TextField } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const DatepickerInput = ({ label, value, onChange }) => {
  return (
    <DateTimePicker
      label={label}
      value={value}
      onChange={onChange}
      renderInput={(props) => <TextField {...props} fullWidth />}
    />
  );
};

export default DatepickerInput;